import React, {Component} from 'react';
import {sortArrayOfObjects} from 'helpers/common-helper';

class BaseUsedTeams extends Component {
    groupTeamUsage(lineups) {
        let teams = {};
        Object.keys(lineups).map((key) => {
            let lineup = lineups[key];
            let teamsUsed = {};

            for (let i in lineup.players) {
                let unit = lineup.players[i];
                let teamName = unit.team;

                if (teamsUsed.hasOwnProperty(teamName)) {
                    teamsUsed[teamName].usedLineupsCount++;
                } else {
                    teamsUsed[teamName] = {
                        usedLineupsCount: 1,
                    };
                }
            }

            Object.keys(teamsUsed).map((teamName) => {
                if (teams.hasOwnProperty(teamName)) {
                    teams[teamName].usedLineupsCount++;
                } else {
                    teams[teamName] = {usedLineupsCount: 1};
                }
            });
        });
        return teams;
    }

    prepareTeams(obj) {
        let tmpArr = [];
        Object.keys(obj).map((key) => {
            let team = obj[key];
            tmpArr.push({
                name: key,
                usedLineupsCount: team.usedLineupsCount,
            });
        });
        return sortArrayOfObjects(tmpArr, 'usedLineupsCount', 'desc');
    }

    getNotFoundView() {
        return (
            <tr key="teams-not-found" className="empty">
                <td>Teams were not found.</td>
            </tr>
        );
    }
}

export {BaseUsedTeams};
